<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass"
    [modalAutomationId]="targetType === 'export-comparison' ? 'target-picker' :  modalAutomationId"
    [resizeHorizontal]="true"
    [resizeHorizontalMin]="modalData.entityType === 'domains' || modalData.entityType === 'alias-list' ? 600 : 450"
    [resizeVertical]="true"
    [resizeVerticalMin]="modalData.entityType === 'domains' || modalData.entityType === 'alias-list' ? 500 : 400"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex">
    <div class="picker-grid">
        <div [ngClass]="targetType !== 'domains' && targetType !== 'alias-list' ? 'grid-container' : 'grid-container-list'"
            [hidden]="targetType === 'export-comparison'" id="lists-section"
            [attr.data-automation-id]="domainOrAliasContainerAutoId.left">
            <div class="grids-header-container">
                <span [attr.data-automation-id]="domainOrAliasContainerAutoId.left + '-label'" class="domains-label"
                    *ngIf="modalData.entityType === 'domains'">Domain lists</span>
                <span [attr.data-automation-id]="domainOrAliasContainerAutoId.left + '-selected-count-label'"
                    [ngClass]="targetType === 'domains'? 'domains-selected-label' : 'selected-label'">Selected: <span
                        class="number-label">
                        {{rowsSelected?.length}}</span>
                </span>
            </div>
            <res-generic-grid [gridName]="gridName" [automationId]="modalAutomationId"
                [updateStatusType]="updateStatusType" *ngIf="targetType !== 'export-comparison'" [(isBusy)]="isBusy"
                [(isBusyMessage)]="isBusyMessage" [pagerVisible]="false" [gridContext]="leftListGridContext"
                [loadDataFinishedCallback]="loadDataFinishedCallback" [columnDefs]="columnDefs"
                [rowSelection]="rowSelection" [requestInfo]="requestInfo" [onSelectionChanged]="onSelectionChanged"
                [responseArrayCallback]="responseArrayCallback" [onCellClicked]="onCellClicked"
                [rowClassRules]="rowClassRules">
            </res-generic-grid>
            <div class="entries-count-container"
                *ngIf="targetType === 'senders' || targetType === 'recipients' || targetType === 'metadata'">
                <span class="entries-count"
                    [attr.data-automation-id]="modalAutomationId + '-count-label'">{{leftGridEntriesCount}}</span>
            </div>
        </div>
        <div *ngIf="targetType === 'domains' || targetType === 'alias-list'" class="resizer-panel">
            <res-resizer [attr.data-automation-id]="modalAutomationId + '-lists-resizer'" anchor="left"
                resizingElementId="lists-section" secondElementId="right-section" [usePercentages]="true"
                [initSize]="63" [minSize]="40" [maxSize]="80" [ellipsisExpander]="true"></res-resizer>
            <div class="grid-right-container" [attr.data-automation-id]="domainOrAliasContainerAutoId.right">
                <div *ngIf="selectedList && selectedRowVisible() && modalData.entityType === 'domains'"
                    class="grids-header-container">
                    <span class="domains-label">Domains</span>
                    <div class="button-container">
                        <li class="dropdown" dropdown>
                            <button dropdownToggle type="button" class="primary-button"
                                [ngClass]="[domainButtonDisabled || rightGridSelectedRows?.length === 0 ? 'disabled' : '']"
                                [attr.data-automation-id]="'domain-entries-domain-button'">
                                <span>Domain</span>
                                <i class="fa fa-caret-down"
                                    [attr.data-automation-id]="'domain-entries-domain-button-icon'"></i>
                            </button>
                            <ul *dropdownMenu class="dropdown-menu">
                                <li class="menu-item" (click)="openDomainButton()">
                                    <div class="menu-item-icon">
                                        <span class="fa-stack">
                                            <i class="fa fa-at"></i>
                                            <i class="fa fa-stack-1x fa-plus"></i>
                                        </span>
                                    </div>
                                    <div class="menu-item-label"
                                        [attr.data-automation-id]="'domain-entries-add-to-new-domain-list-button'">
                                        Add to New Domain List ...</div>
                                </li>
                                <li class="menu-item" (click)="openDomainButton(true)">
                                    <div class="menu-item-icon">
                                        <span class="fa-stack">
                                            <i class="fa fa-at"></i>
                                            <i class="fa fa-stack-1x fa-plus"></i>
                                        </span>
                                    </div>
                                    <div class="menu-item-label"
                                        [attr.data-automation-id]="'domain-entries-add-to-existing-domain-list-button'">
                                        Add to Existing Domain List ...</div>
                                </li>
                            </ul>
                        </li>
                        <span *ngIf="!domainButtonDisabled"
                            [attr.data-automation-id]="'domain-entries-selected-count-label'"
                            class="li-selected-label">Selected: <span class="number-label">
                                {{rightGridSelectedRows?.length}}</span>
                        </span>
                    </div>
                </div>
                <res-generic-grid [gridName]="rightGridName" [automationId]="entriesAutoId"
                    [hidden]="!selectedList || !selectedRowVisible()" [(isBusy)]="isBusyEntries"
                    [(isBusyMessage)]="isBusyMessageEntries" [pagerVisible]="false" [gridContext]="rightListGridContext"
                    [columnDefs]="columnDefsLists" [rowSelection]="rightGridRowSelection"
                    [onSelectionChanged]="onRightGridSelectionChanged">
                </res-generic-grid>
                <div *ngIf="!selectedList || !selectedRowVisible()" class="blank-preview-select">
                    <span>
                        Please select one {{targetType === 'domains' ? 'Domain List' : 'Alias List'}} at a time to
                        load
                        {{targetType === 'domains' ? 'Domains' : 'Aliases'}} here
                    </span>
                </div>
                <div class="entries-count-container"
                    *ngIf="targetType === 'domains' && selectedList && selectedRowVisible()">
                    <span class="entries-count"
                        [attr.data-automation-id]="columnDefsLists[0]?.automationId +  + '-count-label'">{{domainsCount}}</span>
                </div>
            </div>
        </div>

        <div [hidden]="targetType !== 'export-comparison'" class="tree-container">
            <div class="modal-row-column-auto filterClass">
                <res-filter [filterInputAutoId]="modalAutomationId" [clearButtonDataAutoId]="modalAutomationId"
                    [maxChars]=32 [placeholder]='"Filter..."' [callback]="filterData.bind(this)"
                    [autofocusInput]="inputAutoFocused"></res-filter>
            </div>
            <div class="generic-tree-panel">
                <res-generic-tree [automationId]="modalAutomationId + '-tree'"
                    [doubleClickAction]="doubleClickAction.bind(this)"
                    customClasses="generic-tree-navigation-header-panels generic-tree-header-panels-chevron-expanders"
                    [selectedNodeChangedCallback]="selectedNodeChangedCallback"></res-generic-tree>
            </div>
        </div>
    </div>

    <div *ngIf="targetType === 'export-comparison'" class="export-comparison-options">
        <div class="search-term-report" *ngIf="searchTermVisible">
            <res-custom-checkbox [automationId]="modalAutomationId + '-include-search-term-report'"
                [(ngModel)]="includeSearchTermReport" [content]="'Include Search Term Report'"></res-custom-checkbox>
        </div>
        <div class="html-sizes">
            <res-custom-checkbox [automationId]="modalAutomationId + '-provide-html-mhtml-size'"
                [(ngModel)]="provideHTMLSizes" [content]="'Provide HTML/MHTML Sizes'"></res-custom-checkbox>
            <div class="fa fa-hourglass-half"
                title="Enabling this option will convert documents when the report is run. The report may take considerably longer to generate."
                [attr.data-automation-id]="modalAutomationId+'-hour-glass-icon'">
            </div>
        </div>
    </div>
</res-base-modal>